<template>
  <div>
    <div class="body">
      <div class="profileData">
        <Single-Contact-Card
          :loading="loading"
          :profileData="parsedData"
          :companyData="companyData"
          :conatactCount="conatactCount"
          :loadingCompany="loadingCompany"
          :error="errorMsg"
          :dataLoadingInBg="dataLoadingInBg"
        />
      </div>
      <div v-if="dataLoadingInBg" class="find-email-loader">
        Fetching contact information...
      </div>
    </div>
    <!-- <Help-Menu></Help-Menu> -->
  </div>
</template>

<script>
import SingleContactCard from '@/components/linkedin/SingleProfile/SingleContactCard.vue'
// import Helpmenu from '@/components/help/Helpmenu.vue'
import { get, post } from '@/assets/util/rest.js'
import { MxEvent } from '@/assets/util/constants/analytics'
import sharedFunctions from '@/assets/util/functions.js'
import { setTimeout } from 'timers'

export default {
  name: 'LinkedinSingle',
  props: ['json'],
  watch: {
    json: {
      immediate: true,
      handler(newValue, oldValue) {
        if (oldValue != newValue) {
          this.enrichProfileData(newValue)
        }
      }
    }
  },
  data: function() {
    return {
      parsedData: null,
      companyData: null,
      conatactCount: null,
      loading: true,
      loadingCompany: true,
      errorMsg: null,
      timedOut: 5000,
      isRejected: false,
      dataLoadingInBg: false,
      alreadyReturned: false
    }
  },
  components: {
    'Single-Contact-Card': SingleContactCard
    // 'Help-Menu': Helpmenu
  },
  methods: {
    enrichProfileData(profile) {
      this.companyData = null
      this.conatactCount = null
      this.loadingCompany = false
      this.errorMsg = null
      this.alreadyReturned = false
      this.findAndUpdateEmailWithTimeOut(profile)
      // Sales navigator string mismatch in variable name
      this.$store.state.liData = profile.userData
      this.$store.state.isSalesNavigator = profile.isSaleNavigator
    },
    findAndUpdateEmailWithTimeOut(profile) {
      this.findEmailAndUpdateMaskedEmail(profile)
        .then(response => {
          this.trackSingleProfile(profile)
          this.resolveAndUpdateMaskedEmail(response, profile)
        })
        .catch(() => {
          this.loading = false
          this.dataLoadingInBg = false
          this.resetContactData(profile)
        })
    },
    resolveAndUpdateMaskedEmail(response, profile) {
      this.loading = false
      if (response.status == 200) {
        response
          .json()
          .then(res => {
            this.dataLoadingInBg = false
            if (res && res.statusCode === '200') {
              this.$store.state.user.phoneNumberEnabled =
                res.additionalInfo && res.additionalInfo.PHONE_NUMBER == 'true'
              this.updateWithMaskedEmail(res)
            } else if (res.statusCode === '100' && res.error[0].code) {
              this.parsedData.email = null
              if (res.error && res.error[0] && res.error[0].code) {
                this.errorMsg = this.getErrorMsg(res)
              } else {
                this.errorMsg = { msg: res.errorMessage }
              }
              this.resetContactData(profile)
            } else {
              this.resetContactData(profile)
            }
          })
          .catch(e => {
            this.loading = false
            this.resetContactData(profile)
            console.log('err: ' + e)
          })
      } else {
        this.loading = false
        this.resetContactData(profile)
      }
    },
    updateWithMaskedEmail(res) {
      let formatedRes = this.formatResponse(res)
      this.parsedData = {
        ...formatedRes,
        phone: formatedRes.phoneNumberFromVendor
      }
      this.parsedData.contactAlreadyOwned = res.contactOwned
      if (formatedRes.companyId) {
        this.getCompanyData(formatedRes.companyId)
        // this.getContactCount(formatedRes.companyId)
      }
    },
    findEmailAndUpdateMaskedEmail(profile) {
      this.parsedData = profile
      this.loading = true
      const reqData = this.constructReqData(profile)
      const that = this
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (!that.alreadyReturned) {
            that.dataLoadingInBg = true
            that.loading = false
            that.resetContactData(profile)
            setTimeout(() => {
              reject()
            }, 5000)
          }
        }, that.timedOut)
        post('lp/spEmail.htm', reqData)
          .then(response => {
            that.alreadyReturned = true
            resolve(response)
          })
          .catch(e => {
            that.alreadyReturned = true
            reject()
            console.log('err: ' + e)
          })
      })
    },
    resetContactData(profile) {
      this.companyData = null
      this.parsedData = profile
      this.loadingCompany = false
    },
    constructReqData(profileData) {
      const data = sharedFunctions.getFilteredData(profileData)

      data.salesNavigator = profileData.isSaleNavigator
      return data
    },
    getCompanyData(compId) {
      this.loadingCompany = true
      get('lp/getCompany.htm?id=' + compId)
        .then(response => {
          this.loadingCompany = false
          if (response.status == 200) {
            response
              .json()
              .then(res => {
                //console.log('comapny data ', res)
                this.companyData = res
                //console.log('data: ' + JSON.stringify(res))
              })
              .catch(e => {
                this.loadingCompany = false
                console.log('err: ' + e)
              })
          } else {
            this.loadingCompany = false
            //console.log('status: ' + response.status)
          }
        })
        .catch(e => {
          this.loadingCompany = false
          console.log('error: ' + e)
        })
    },
    // getContactCount(compId) {
    //   get('lp/company/' + compId + '/contactCount.htm')
    //     .then(response => {
    //       if (response.status == 200) {
    //         response
    //           .json()
    //           .then(res => {
    //             this.conatactCount = res
    //             //console.log('data: ' + JSON.stringify(res))
    //           })
    //           .catch(e => {
    //             console.log('err: ' + e)
    //           })
    //       } else {
    //         console.log('status: ' + response.status)
    //       }
    //     })
    //     .catch(e => {
    //       console.log('error: ' + e)
    //     })
    // },
    formatResponse(data) {
      let newRes = data && data.response ? data.response : {}
      if (data && data.creditLeft) newRes.creditLeft = data.creditLeft
      if (data && data.viewsLeft) newRes.viewsLeft = data.viewsLeft

      return newRes
    },
    getErrorMsg(res) {
      return sharedFunctions.getRespectiveErrorMsg(res)
    },
    trackSingleProfile(data) {
      sharedFunctions.track(
        data.isSaleNavigator
          ? MxEvent.singleContactViewedSN
          : MxEvent.singleContactViewed,
        {
          contactName: data.fullName,
          contactCompany: data.company.name,
          linkedinUrl: data.linkedinId
        },
        this.$store.state
      )
    }
  },
  created() {
    const autoTrigger = new URL(window.location.href).searchParams.get(
      'autoTrigger'
    )
    if (autoTrigger) {
      this.$store.state.linkedin.autoTrigger = true
      window.history.replaceState(null, null, window.location.pathname)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  padding: 40px 0 0;
}
ul {
  margin: 0;
  list-style-type: none;
  padding: 0;
  li {
    display: flex;
    width: 100%;
  }
}
.single-list-create {
  padding: 5px 0;
  height: 42px;
  padding-top: 2px;
  display: flex;
  flex-flow: row wrap;
  box-shadow: 0px 2px 3px 0px #efefef;
  .list-search {
    padding: 5px 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    span {
      font-size: 14px;
      padding-right: 7px;
      color: #878787;
      text-transform: capitalize;
    }
  }
}
.find-email-loader {
  padding: 10px;
  font-size: 12px;
  color: $grey-color;
}
.body {
  position: relative;
  .max-height {
    height: -webkit-fill-available;
  }
}
.blur-li {
  position: sticky;
  justify-content: center;
  bottom: 0px;
  background: rgba(255, 255, 255);
  -webkit-box-shadow: 0px -6px 20px 20px $white;
  box-shadow: 0px -6px 20px 20px $white;
  padding: 20px 0px 20px 0px;
  margin-top: 10px;
  button {
    padding: 14px;
    width: 80%;
    font-size: 16px;
  }
}
.single-list-loader {
  box-shadow: 0px 2px 3px 0px #efefef;
}
</style>
